// Title Caps
//
// Ported to JavaScript By John Resig - http://ejohn.org/ - 21 May 2008
// Original by John Gruber - http://daringfireball.net/ - 10 May 2008
// Ported to CoffeeScript and improved by Calvin Correli - 2 April 2015
// License: http://www.opensource.org/licenses/mit-license.php
//
const small =
  '(' +
  [
    'a',
    'aboard',
    'about',
    'above',
    'absent',
    'across',
    'after',
    'against',
    'along',
    'alongside',
    'amid',
    'amidst',
    'among',
    'amongst',
    'an',
    'and',
    'around',
    'as',
    'as',
    'aslant',
    'astride',
    'at',
    'athwart',
    'atop',
    'barring',
    'before',
    'behind',
    'below',
    'beneath',
    'beside',
    'besides',
    'between',
    'beyond',
    'but',
    'by',
    'despite',
    'down',
    'during',
    'except',
    'failing',
    'following',
    'for',
    'for',
    'from',
    'in',
    'inside',
    'into',
    'like',
    'mid',
    'minus',
    'near',
    'next',
    'nor',
    'notwithstanding',
    'of',
    'off',
    'on',
    'onto',
    'opposite',
    'or',
    'out',
    'outside',
    'over',
    'past',
    'per',
    'plus',
    'regarding',
    'round',
    'save',
    'since',
    'so',
    'than',
    'the',
    'through',
    'throughout',
    'till',
    'times',
    'to',
    'toward',
    'towards',
    'under',
    'underneath',
    'unlike',
    'until',
    'up',
    'upon',
    'via',
    'v',
    'v.',
    'vs',
    'vs.',
    'when',
    'with',
    'within',
    'without',
    'worth',
    'yet',
  ].join('|') +
  ')'
const punct = '([!"#$%&\'’()*+,./:;<=>?@[\\\\\\]^_`{|}~-]*)'

const lower = (word) => word.toLowerCase()

const capitalize = (word) => word.substr(0, 1).toUpperCase() + word.substr(1)

const upper = (word) => word.toUpperCase()

export function toTitleCaps(title) {
  const parts = []
  const split = /[:.;?!] |(?: |^)["Ò]/g
  let index = 0

  while (true) {
    const m = split.exec(title)

    parts.push(
      title
        .substring(index, m ? m.index : title.length)
        .replace(/\b([A-Za-z][a-z.'’Õ]*)\b/g, function (all) {
          if (/[A-Za-z]\.[A-Za-z]/.test(all)) {
            return all
          } else {
            return capitalize(all)
          }
        })
        .replace(RegExp('\\b' + small + '\\b', 'ig'), lower)
        .replace(
          RegExp('^' + punct + small + '\\b', 'ig'),
          (all, punct, word) => punct + capitalize(word)
        )
        .replace(RegExp('\\b' + small + punct + '$', 'ig'), capitalize)
    )

    index = split.lastIndex

    if (m) {
      parts.push(m[0])
    } else {
      break
    }
  }

  return parts
    .join('')
    .replace(/ V(s?)\. /gi, ' v$1. ')
    .replace(/(['’Õ])S\b/gi, '$1s')
    .replace(/\b(AT&T|Q&A)\b/gi, upper)
    .replace(/\{\{[^}]+\}\}/, lower)
}
